/**
 * Order bump do carrinho deslizante (task 21).
 *
 * O drawer é reescrito via innerHTML a cada mudança no carrinho, então o elemento é recriado a cada
 * render: o "fechado" mora no sessionStorage (dura até fechar a aba) e é reaplicado no constructor.
 * Setas rolam um card por vez sobre o scroll-snap já existente e desabilitam nas pontas.
 */
if (!customElements.get('cart-bump')) {
  customElements.define(
    'cart-bump',
    class CartBump extends HTMLElement {
      static storageKey = 'cartBumpDismissed';

      constructor() {
        super();

        if (CartBump.isDismissed()) {
          this.hidden = true;
          return;
        }

        this.list = this.querySelector('.cart-bump__list');
        this.prevButton = this.querySelector('[data-bump-prev]');
        this.nextButton = this.querySelector('[data-bump-next]');

        this.querySelector('.cart-bump__close')?.addEventListener('click', this.dismiss.bind(this));
        this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
        this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
        this.list?.addEventListener('scroll', this.updateArrows.bind(this), { passive: true });
      }

      connectedCallback() {
        if (!this.hidden) requestAnimationFrame(() => this.updateArrows());
      }

      static isDismissed() {
        try {
          return sessionStorage.getItem(CartBump.storageKey) === 'true';
        } catch {
          return false;
        }
      }

      dismiss() {
        try {
          sessionStorage.setItem(CartBump.storageKey, 'true');
        } catch {
          // sem storage (aba privada restrita): fecha só até o próximo render
        }
        this.hidden = true;
        this.closest('cart-drawer')?.querySelector('#CartDrawer-Checkout')?.focus();
      }

      scrollByCard(direction) {
        const card = this.list.querySelector('.cart-bump__item');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.list.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      updateArrows() {
        if (!this.list || !this.prevButton || !this.nextButton) return;
        const maxScroll = this.list.scrollWidth - this.list.clientWidth;
        this.prevButton.disabled = this.list.scrollLeft <= 1;
        this.nextButton.disabled = this.list.scrollLeft >= maxScroll - 1;
      }
    }
  );
}
